<template>
    <div id="custSelect" class="cust-select">
        <v-select label="id" ref='CustSearchSelect' placeholder="Seleccionar cliente..." :value="this.$store.state.customer"
            :filterable="false" :options="options" @search="onSearch" @input="setCustomer">
            <template slot="no-options">
                Buscar clientes...
            </template>
            <template slot="option" slot-scope="option">
                <div>
                    {{ option.id }} - {{ option.nif }}
                    {{ option.name }}
                    ({{ option.alias }})
                </div>
            </template>
            <template slot="selected-option" scope="option">
                <div>
                    {{ option.id }} - 
                    {{ option.name }}
                    ({{ option.alias }})
                </div>
            </template>
        </v-select>         
    </div>
</template>

<script>
import mixin from '@/components/mixin.js'
import _ from 'lodash'

export default {
    mixins:[mixin],
    name: 'CustSelect',    
    data() {
        return {    
            options : [],
            inputtimeout: 0
        }
    },
    methods: {
        onSearch(search, loading) {         
            
            this.debouncedSearch(search,loading);        
        },
        debouncedSearch: _.debounce(function (search,loading) { this.search(search,loading); }, 300),
        search(search,loading) {
           this.axios.post(this.ApiBaseUrl + 'CustSearch', 
                            JSON.stringify(search), 
                            {headers: {"Content-Type": "application/json"}})
                .then((response) => {        
                    this.options = response.data;               
                    loading(false); 
                })
        },
        
        
        setCustomer(newvalue) {
            if (newvalue)
            {
                let curCust
                if (this.$store.state.customer != null)
                curCust = this.$store.state.customer.id
                 if (curCust != newvalue.id) {
                this.$store.commit('setCust', newvalue)
                this.$store.commit('SetShipToCode', '')
                this.$store.commit('SetAuthContact', '')
                this.GetAuthContacts()
                this.GetShipToCode()
                    .then((data) => {
                        this.$store.commit('updateCombineShipments', this.$store.state.customer.combineShip)
                        if (this.$store.state.items.length > 0)
                            this.ParkAndCalcDisc();
                    })
                }
            }
                           
        },
        ParkAndCalcDisc() {
            this.parkSale().then((data) => {
                var req = {
                    orderno: this.$store.state.curOrder,                    
                    discamount: parseFloat(0),
                    disctype: "0",  
                    ordertype: this.$store.state.curDocType                  
                }
                this.CalcDisc(req).then((data) => {
                    this.RecoverSale(this.$store.state.curOrder)
                })
            })
        },
        GetShipToCode() {
            return this.axios.post(this.ApiBaseUrl + 'CustSearch/GetCustShipTo', 
                                   JSON.stringify(this.$store.state.customer.id), 
                                   { headers: {"Content-Type": "application/json"} })
                .then((response) => {
                    //if (response.data.length > 0)
                    this.$store.commit('setcustShipToList', response.data)                 
                })
        },
        GetAuthContacts() {
            this.axios.get(this.ApiBaseUrl + 'contact/' + this.$store.state.customer.id, { headers: {"Content-Type": "application/json"} })
                .then((response) => {
                    this.$store.commit('setAuthContactList', response.data)
                })
        }
    }
}
</script>